import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { AttributeComponent } from '../../interfaces/attribute.component';
import { AttributeDefinition } from '../../models/attribute-definition';
import { FormControl, FormGroup } from '@angular/forms';
import { AttributeControlService } from '../../attribute-control-service';
import { DatepickerUtilsService } from 'src/app/services/ui/datepicker-utils.service';
import { NgxMatDatetimePicker } from '@angular-material-components/datetime-picker';
import * as moment_ from 'moment';
const moment = moment_;

@Component({
  selector: 'app-date-time',
  templateUrl: './date-time.component.html',
  styleUrls: ['./date-time.component.scss']
})
export class DateTimeComponent implements OnInit, AttributeComponent {
  @Input() formGroup: FormGroup;
  @Input() attributeDefinition: AttributeDefinition;

  @Output() onRemove = new EventEmitter<number>();

  @ViewChild('dateTimePicker') dateTimePicker: NgxMatDatetimePicker<Date>;
  public moment = moment;

  openAt: Date = new Date();
  defaultTime: number[] = [12, 0, 0];

  constructor(
    public _attributeControlService: AttributeControlService<Date | null>,
    public _datePickerUtilService: DatepickerUtilsService
  ) { }

  ngOnInit(): void {
    const initial: Date | null = this._datePickerUtilService.getDate(this.attributeDefinition.value);
    this._attributeControlService.addFormControl(
      this.attributeDefinition.formControlName,
      this.attributeDefinition.isRequired,
      initial,
      this.formGroup
    );
  }

  get control(): FormControl {
    return this.formGroup.get(this.attributeDefinition.formControlName) as FormControl;
  }

  get label(): string {
    return (this.attributeDefinition?.name || '').replace(/\s*[:*]+$/, '').trim();
  }

  getErrorMessage(): string {
    if (!this.control) return '';
    if (this.control.hasError('required')) return `${this.label} is required.`;
    if (this.control.hasError('matDatepickerParse') || this.control.hasError('ngxMatDatetimePickerParse')) {
      return `Invalid ${this.label.toLowerCase()}.`;
    }
    return '';
  }

  private getDefaultTime(): number[] {
    const m = this.control?.value ? moment(this.control.value) : moment();
    return [m.hour(), m.minute(), 0];
  }

  private getOpenAt(): Date {
    const base = this.control?.value ? moment(this.control.value) : moment();
    this.defaultTime = this.getDefaultTime();
    base.set('hour', this.defaultTime[0]);
    base.set('minute', this.defaultTime[1]);
    base.set('second', this.defaultTime[2]);
    return base.toDate();
  }

  onOpen(): void {
    this.openAt = this.getOpenAt();
    this.dateTimePicker?.select(this.openAt);
  }

  value(): string | null {
    const val: Date | null = this.control.value;
    this.attributeDefinition.value = val;
    return val ? this._datePickerUtilService.getDateString(val, true) : null;
  }

  clear(ev?: MouseEvent): void {
    ev?.stopPropagation();
    this.control.setValue(null, { emitEvent: true });
    this.control.markAsDirty();
    this.control.markAsTouched();
    this.attributeDefinition.value = null;
  }

  ngOnDestroy(): void {
    this._attributeControlService.removeControl(this.attributeDefinition.formControlName, this.formGroup);
  }
}
